import { createFileRoute } from "@tanstack/react-router";
import FoodWellnessPantryPage from "@/pages/FoodWellnessPantryPage";
export const Route = createFileRoute("/food-wellness-pantry")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Food & Wellness Pantry | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Food and Wellness Pantry resources from Neuro Wellness TMS in Coral Springs, FL. Community support for mental health and depression treatment patients.",
        },
        {
          property: "og:title",
          content: "Food & Wellness Pantry | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Food and Wellness Pantry resources from Neuro Wellness TMS in Coral Springs, FL. Community support for mental health and depression treatment patients.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/food-and-wellness-pantry",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/food-and-wellness-pantry",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FoodWellnessPantryPage />;
}
